import React from 'react';

import { Routes } from './router';

export default function App() {
  return <Routes />;
}